(function () {
  const ROOT = '[data-facet-tier-root]';

  function parsePayload(fieldset) {
    const script = fieldset.querySelector('script[data-facet-tier-payload]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (_) {
      return [];
    }
  }

  function hydrateDeferredTiers(fieldset, maxTier) {
    const payload = parsePayload(fieldset);
    if (!payload.length) return;

    for (let t = 1; t <= maxTier; t++) {
      const hydratedKey = `hydratedTier_${t}`;
      if (fieldset.dataset[hydratedKey]) continue;

      const entry = payload.find((p) => Number(p.t) === t);
      if (!entry || !entry.html) continue;

      const controlLi = fieldset.querySelector(`li.facets__item--tier-control[data-facet-tier-depth="${t}"]`);
      if (!controlLi) continue;

      const tpl = document.createElement('template');
      tpl.innerHTML = String(entry.html).trim();
      controlLi.after(...tpl.content.childNodes);

      fieldset.dataset[hydratedKey] = '1';
    }
  }

  function syncFieldset(fieldset) {
    if (!fieldset.matches?.(ROOT)) return;

    const chunk = parseInt(fieldset.dataset.facetChunk || '12', 10);
    let maxTier = parseInt(fieldset.dataset.facetExpandedTier || '0', 10);
    const count = parseInt(fieldset.dataset.facetValueCount || '0', 10);
    if (Number.isNaN(maxTier)) maxTier = 0;

    hydrateDeferredTiers(fieldset, maxTier);

    fieldset.querySelectorAll('[data-facet-tier-item]').forEach((li) => {
      const t = parseInt(li.dataset.facetTierItem, 10);
      const hide = !Number.isNaN(t) && t > maxTier;
      li.classList.toggle('hidden', hide);
    });

    fieldset.querySelectorAll('[data-facet-tier-depth]').forEach((row) => {
      const depth = parseInt(row.dataset.facetTierDepth, 10);
      if (Number.isNaN(depth)) return;

      const inlineFirst = fieldset.hasAttribute('data-facet-inline-first');
      let needRow;
      if (inlineFirst && depth === 1) {
        needRow = count > 11;
      } else {
        needRow = count > depth * chunk;
      }
      if (!needRow) {
        row.classList.add('hidden');
        return;
      }

      const visible = depth === 1 || maxTier >= depth - 1;
      row.classList.toggle('hidden', !visible);

      const btn = row.querySelector('[data-facet-tier-toggle]');
      const more = btn?.querySelector('.label-show-more');
      const less = btn?.querySelector('.label-show-less');
      if (!btn || !more || !less) return;

      const expanded = maxTier >= depth;
      more.classList.toggle('hidden', expanded);
      less.classList.toggle('hidden', !expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function syncAll(root = document) {
    root.querySelectorAll(ROOT).forEach(syncFieldset);
  }

  function onDocumentClick(e) {
    const btn = e.target.closest('[data-facet-tier-toggle]');
    if (!btn) return;
    const row = btn.closest('[data-facet-tier-depth]');
    const fieldset = btn.closest(ROOT);
    if (!row || !fieldset) return;

    const depth = parseInt(row.dataset.facetTierDepth, 10);
    if (Number.isNaN(depth)) return;

    let maxTier = parseInt(fieldset.dataset.facetExpandedTier || '0', 10);
    if (Number.isNaN(maxTier)) maxTier = 0;

    const currentlyExpanded = maxTier >= depth;
    fieldset.dataset.facetExpandedTier = String(currentlyExpanded ? depth - 1 : depth);
    syncFieldset(fieldset);
  }

  if (!window.__facetTierClickBound) {
    window.__facetTierClickBound = true;
    document.addEventListener('click', onDocumentClick);
  }
  document.addEventListener('DOMContentLoaded', () => syncAll());

  window.FacetTierShowMore = { syncFieldset, syncAll };
})();
